/*
 * @Descripttion:
 * @Date: 2024-12-30 10:12:42
 */

// 签署方式enum
export enum SignType {
  ONLINE = 1,
  OFFLINE = 2
}

// 签署方式
export const SIGN_TYPE = [
  { label: '线上签署', value: SignType.ONLINE },
  { label: '线下签署', value: SignType.OFFLINE }
];

// 合同状态enum
export enum ContractStatus {
  /**
   * 未签署
   */
  UNSIGNED = 0,
  /**
   * 签署中
   */
  SIGNING = 1,
  /**
   * 已完成
   */
  COMPLETED = 2,
  /**
   * 已过期
   */
  EXPIRED = 5,
  /**
   * 已拒绝
   */
  REJECTED = 3
}

// 合同状态
export const CONTRACT_STATUS = [
  { label: '签署中', value: ContractStatus.SIGNING },
  { label: '已完成', value: ContractStatus.COMPLETED },
  { label: '已过期', value: ContractStatus.EXPIRED },
  { label: '已拒绝', value: ContractStatus.REJECTED }
];

/**
 * 合同类型
 */
export enum ContractType {
  // 平台服务合同
  PLATFORM = 1,
  // 市场服务合同
  MARKET = 3,
  // 渠道服务合同
  CHANNEL = 2,
  // 项目服务合同
  PROJECT = 4,
  // 市场服务人员合同
  MARKET_PERSON = 5
}

export const CONTRACT_TYPE = [
  { label: '平台服务合同', value: ContractType.PLATFORM },
  { label: '市场服务合同', value: ContractType.MARKET },
  { label: '渠道服务合同', value: ContractType.CHANNEL },
  { label: '项目服务合同', value: ContractType.PROJECT },
  { label: '市场服务人员合同', value: ContractType.MARKET_PERSON }
];

// 签署状态
export enum SignStatus {
  UNSIGNED = 0,
  // 签署中
  SIGNING = 1,
  // 已签署
  SIGNED = 2,
  REFUSED = 3,
  // 签署失败
  FAILED = 4
}

export const SIGH_STATUS = {
  [SignStatus.SIGNED]: {
    label: '已签署',
    type: 'success'
  },
  [SignStatus.SIGNING]: {
    label: '未签署',
    type: 'primary'
  },
  [SignStatus.UNSIGNED]: {
    label: '未签署',
    type: 'primary'
  },
  [SignStatus.FAILED]: {
    label: '签署失败',
    type: 'danger'
  },
  [SignStatus.REFUSED]: {
    label: '拒绝签署',
    type: 'danger'
  }
};

// 交易结构
export const TRADE_STRUCTURE = [
  { label: '通用', value: 0 },
  { label: '汇总申报', value: 1 },
  { label: '运营基地', value: 4 },
  { label: '委托代发', value: 3 },
  { label: '委托代开', value: 6 },
  { label: '个体产品', value: 5 }
];

export enum AuthStatus {
  /**
   * 审核中
   */
  AUDITING = 20,
  /**
   * 审核通过
   */
  PASS = 30,
  /**
   * 审核未通过
   */
  FAILED = 40
}

// 合同模板页还是合同管理
export enum ContractMenuType {
  TEMPLATE = 1,
  MANAGEMENT = 2
}

// 角色类型
export enum RoleType {
  // 工业
  INDUSTRY = 1,
  // 服务商
  ASP = 2,
  // 供应商
  SUPPLIER = 3,
  // 基地
  BASE = 4
}
